module.exports = __webpack_public_path__ + "static/media/reflections.5933deae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reportcentre/reflections.jpg
// module id = 2940
// module chunks = 0